import { render, staticRenderFns } from "./dyyjsh.vue?vue&type=template&id=1dd7d264&scoped=true"
import script from "./dyyjsh.vue?vue&type=script&lang=ts"
export * from "./dyyjsh.vue?vue&type=script&lang=ts"
import style0 from "./dyyjsh.vue?vue&type=style&index=0&id=1dd7d264&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd7d264",
  null
  
)

export default component.exports